import noop from 'utils/noop';
import { BUTTON_VARIANTS, IconButton, BUTTON_SIZES } from 'ui/button';
import { DesktopDevice, MobileDevice, AnimatedRefreshIcon } from 'ui/icons';
import { spacing } from 'ui/theme';
import { SegmentedControl, SegmentedControlOption } from 'ui/segmentedControl';
import { Tooltip } from '../../../../ui/tooltip';

import {
  displayContent,
  EmailPreviewType,
  PreviewControlContainer,
  TemplateEditViews,
} from '../../common';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { usePreviewWithDataContext } from '../../context/PreviewWithDataContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useEmailPreviewContext } from '../context/EmailPreviewContext';

export const Controls = () => {
  const { view } = useQueryParamContext();
  const { canRefreshPreview } = usePreviewWithDataContext();
  const {
    isLoading: isRefreshing,
    onRefreshPreview,
    selectedPreview,
    setSelectedPreview,
  } = useEmailPreviewContext();
  const { hasContent } = useEditableFieldsContext();
  const isPreviewWithData = view === TemplateEditViews.preview;
  const ORDERED_PREVIEWS = [EmailPreviewType.Desktop, EmailPreviewType.Mobile];

  const options: SegmentedControlOption[] = ORDERED_PREVIEWS.map((option) => ({
    key: option,
    Icon: option === EmailPreviewType.Desktop ? DesktopDevice : MobileDevice,
    tooltip: {
      content:
        option === EmailPreviewType.Desktop
          ? displayContent.labelDesktop
          : displayContent.labelMobile,
    },
    value: option,
  }));

  return (
    <PreviewControlContainer>
      {setSelectedPreview !== noop && (
        <SegmentedControl
          onSelect={setSelectedPreview}
          optionMinWidth={spacing.plusHalf}
          options={options}
          value={selectedPreview}
          data-test="template-editor-segmented-control"
        />
      )}
      {isPreviewWithData && (
        <Tooltip tooltipContent={'Refresh'}>
          <IconButton
            isDisabled={!canRefreshPreview || !hasContent}
            onClick={() => onRefreshPreview()}
            size={BUTTON_SIZES.SMALL}
            variant={BUTTON_VARIANTS.SECONDARY}
            data-test="template-editor-refresh-icon-button"
          >
            <AnimatedRefreshIcon $isAnimating={isRefreshing} />
          </IconButton>
        </Tooltip>
      )}
    </PreviewControlContainer>
  );
};

export default Controls;
